<template>
    <div
        v-resize:throttle.10="getDimensions"
        class="canvasWrapper"
    >
        <slot />
    </div>
</template>

<script>
import resize from 'vue-resize-directive';

export default {
    name: 'CanvasWrapper',
    directives: {
        resize
    },
    props: {
        im: {
            type: Function,
            default() {
                return null;
            }
        },
        wrapper: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.getDimensions();
    },
    methods: {
        getDimensions() {
            this.wrapper.width = this.$el.clientWidth;
            this.wrapper.height = this.$el.clientHeight;
        }
    }
};
</script>

<style lang="scss" scoped>
.canvasWrapper {
    background-color: #000000;
    position: relative;
    overflow: visible;
    flex: 1;
    border: 1px solid black;
}
</style>
